export class Const {


	public static RUN_CONTACT_US:string  = '/RUN_CONTACT_US'
	public static RUN_SUBSCRIBE_NEWSLETTER:string  = '/RUN_SUBSCRIBE_NEWSLETTER'

	
}